import styled from '@emotion/styled';
import React from 'react';
import Button from '../../atoms/button';
import { useRouter } from 'next/router';
import { hasSelectedGender } from '../../organisms/algolia-plp/utils/refinementHelpers';

const outletRed = '#de4233';

const SectionWrapper = styled.section`
  background-color: ${outletRed};
  position: relative;
  z-index: ${({ theme }) => theme.layers.backstage};
`;

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;

  @media (min-width: ${(props) => props.theme.breakpoint.medium}) {
    align-items: center;
    flex-direction: row;
    min-height: 229px;
    margin: auto;
    justify-content: center;
  }
  @media (max-width: ${(props) => props.theme.breakpoint.medium}) {
    margin: 0 3rem 0 3rem;
  }
`;

const OutletBtn = styled(Button)`
  margin-top: ${(props) => props.theme.modularScale.twenty};
  outline: 0;
  background-color: ${outletRed};
  width: 132.25px;
  height: 35px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 0.2rem solid ${(props) => props.theme.color.white};
  font-family: 'GT Pressura Web';
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => props.theme.modularScale.fourteen};
  line-height: 19px;
  padding: 0;

  color: ${(props) => (props.active ? outletRed : props.theme.color.white)};
  background-color: ${(props) => (props.active ? props.theme.color.white : outletRed)};

  @media (max-width: ${(props) => props.theme.breakpoint.medium}) {
    width: 120px;
    margin-top: 0;
  }
`;

const Content = styled.div`
  max-width: 423px;

  font-family: 'GT Walsheim Web';
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => props.theme.modularScale.sixteen};
  line-height: 22px;
  text-align: center;
  color: ${(props) => props.theme.color.white};
  flex: none;
  order: 0;
  flex-grow: 0;

  @media (max-width: ${(props) => props.theme.breakpoint.medium}) {
    width: auto;
    height: auto;
    margin-bottom: ${(props) => props.theme.modularScale.twentyFour};
  }
`;

const Image = styled.img`
  max-width: 294px;
  height: 79px;
  opacity: 1;

  @media (min-width: ${(props) => props.theme.breakpoint.medium}) {
    margin-left: 68px;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.medium}) {
    max-width: 182px;
    height: 49px;
    margin: ${(props) => props.theme.modularScale.thirtyTwo} 0 ${(props) => props.theme.modularScale.thirtyTwo} 0;
  }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 13px;
  flex-wrap: wrap;

  @media (max-width: ${(props) => props.theme.breakpoint.medium}) {
    width: 253px;
    padding-bottom: ${(props) => props.theme.modularScale.twenty};
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const nav = {
  baby: {
    name: 'Baby',
    navigationUrl: '/shop/outlet/baby'
  },
  girl: {
    name: 'Girl',
    navigationUrl: '/shop/outlet/kids?gender=Girl'
  },
  boy: {
    name: 'Boy',
    navigationUrl: '/shop/outlet/kids?gender=Boy'
  },
  shopAll: {
    name: 'Shop All',
    navigationUrl: '/shop/outlet',
    shopAll: true
  }
};

const OutletHeader = () => {
  const router = useRouter();

  function handleOnClick(navigationUrl, e, shopAll = false) {
    e.preventDefault();
    if (!isActiveLink(navigationUrl, shopAll)) {
      router.push(navigationUrl);
    }
  }

  function isActiveLink(navigationUrl, shopAll = false) {
    const { asPath, query = {} } = router;
    if (shopAll) {
      const urlParts = asPath.split('?')[0];
      return urlParts.endsWith(navigationUrl);
    } else {
      if (navigationUrl === nav['girl'].navigationUrl) {
        return hasSelectedGender(query, 'Girl');
      } else if (navigationUrl === nav['boy'].navigationUrl) {
        return hasSelectedGender(query, 'Boy');
      } else {
        return asPath.includes(navigationUrl);
      }
    }
  }

  return (
    <SectionWrapper>
      <MainWrapper>
        <ContentWrapper>
          <Content>
            Introducing Maisonette Outlet, featuring your favorite baby and kids brands, at unbeatable prices, all year
            long. Stock up on sale and save on clothing, gear and more.
          </Content>
          <ButtonsWrapper>
            {Object.keys(nav).map((key) => {
              const navItem = nav[key];
              const isActive = isActiveLink(navItem.navigationUrl, navItem.shopAll);
              return (
                <OutletBtn
                  key={navItem.name}
                  isLink={!isActive}
                  href={!isActive ? navItem.navigationUrl : undefined}
                  onClick={(e) => handleOnClick(navItem.navigationUrl, e, navItem.shopAll)}
                  active={isActive}>
                  {navItem.name}
                </OutletBtn>
              );
            })}
          </ButtonsWrapper>
        </ContentWrapper>
        <Image src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/images/outlet-icon.png`}></Image>
      </MainWrapper>
    </SectionWrapper>
  );
};

export default OutletHeader;
